<template>
  <div style="margin-left: 14px">
    <b-row style="padding-bottom: 10px">
      <b-button
        v-b-modal.modal-save-notification
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="success"
        class="btn-icon"
        @click="editReview()"
      >
        <feather-icon icon="EditIcon" />
        Edit
      </b-button>
      <div style="width: 10px" />
      <b-button
        variant="gradient-danger"
        class="btn-icon"
        @click="askDeleteReview()"
      >
        <feather-icon icon="DeleteIcon" />
        Delete
      </b-button>
    </b-row>

    <b-row>
      <DataTable
        ref="reviewsTable"
        api="/admin/reviews"
        :columns="columns"
        :on-row-selected-callback="onReviewSelected"
      />
    </b-row>
    <b-modal
      id="modal-save-review"
      cancel-variant="outline-secondary"
      ok-title="Save"
      cancel-title="Close"
      centered
      size="lg"
      title="Add/Save Review"
      @ok="saveReview"
    >
      <b-form>
        <b-form-group>
          <label for="book">Book</label>
          <b-form-input
            id="book"
            v-model="review.bookId"
            name="email"
            placeholder="BookId"
            disabled="disabled"
          />
        </b-form-group>
        <b-form-group>
          <label>Account Email:</label>
          <b-form-input
            id="email"
            v-model="review.email"
            name="email"
            placeholder="Email"
          />
        </b-form-group>
        <b-form-group>
          <label>Title:</label>
          <b-form-input
            id="title"
            v-model="review.title"
            placeholder="Title"
          />
        </b-form-group>
        <b-form-group>
          <label>Rating:</label>
          <star-rating
            v-model="review.rating"
            :rating="1"
            :increment="1"
          />
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            id="approved"
            v-model="review.approved"
            name="approved"
          >
            Approved
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <label>Description:</label>
          <quill-editor
            id="description"
            v-model="review.description"
            :options="snowOption"
          />
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import DataTable from '@core/components/data-table/DataTable.vue'
import firebase from 'firebase'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { quillEditor } from 'vue-quill-editor'
import StarRating from 'vue-star-rating'
import {
  BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BRow,
} from 'bootstrap-vue'

export default {
  components: {
    DataTable,
    quillEditor,
    StarRating,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BRow,
  },
  data() {
    return {
      selectedReview: undefined,
      snowOption: {
        theme: 'snow',
      },
      review: {
        title: '', description: '', rating: 5, approved: false, id: undefined,
      },
      columns: [
        { key: 'bookId', label: 'BOOK', visible: true },
        { key: 'description', label: 'Description', visible: true },
        { key: 'email', label: 'Account', visible: true },
        { key: 'platform', label: 'Platform', visible: true },
        { key: 'rating', label: 'Rating', visible: true },
        { key: 'created', label: 'Created', visible: true },
      ],
    }
  },
  methods: {
    askDeleteReview() {
      if (this.selectedReview !== undefined) {
        this.$bvModal
          .msgBoxConfirm(`Are you sure you want to delete ?${this.selectedReview} review ?`, {
            cancelVariant: 'outline-secondary',
          })
          .then(value => {
            if (value) {
              this.deleteReview()
            }
          })
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Please select a review',
            icon: 'EditIcon',
            variant: 'danger',
          },
        })
      }
    },
    deleteReview() {
      this.loader('block')
      const url = `${this.$readerURL}/admin/reviews/${this.selectedReview}`
      const temp = this
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.delete(url,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          temp.$refs.reviewsTable.loadData()
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    editReview() {
      if (this.selectedReview !== undefined) {
        this.loader('block')
        const url = `${this.$readerURL}/admin/reviews/${this.selectedReview}`
        firebase.auth().currentUser.getIdToken(false).then(idToken => {
          axios.get(url,
            {
              headers: {
                Authorization: idToken,
              },
            }).then(response => {
            this.loader('none')

            this.review.bookId = response.data.bookId
            this.review.email = response.data.email
            this.review.id = response.data.id
            this.review.title = response.data.title
            this.review.description = response.data.description
            this.review.approved = response.data.approved
            this.review.rating = response.data.rating
            this.$bvModal.show('modal-save-review')
            return response
          }).catch(error => {
            this.loader('none')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error,
                icon: 'EditIcon',
                variant: 'error',
              },
            })
          })
        })
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Please select a review',
            icon: 'EditIcon',
            variant: 'danger',
          },
        })
      }
    },
    onReviewSelected(id) {
      if (id.length > 0) {
        this.selectedReview = id[0].id
      } else {
        this.selectedReview = undefined
      }
    },
    saveReview() {
      const review = {
        id: this.review.id,
        email: this.review.email,
        title: this.review.title,
        description: this.review.description,
        rating: this.review.rating,
        bookId: this.review.bookId,
        approved: this.review.approved,
      }

      const url = `${this.$readerURL}/admin/books/reviews/${review.id}`
      this.loader('block')
      const temp = this
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, review,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })

          temp.review.title = ''
          temp.review.description = ''
          temp.approved = false
          temp.rating = 0
          temp.id = undefined
          temp.$refs.reviewsTable.loadData()
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/quill.scss';
</style>
